import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { Cursor } from '@wonderlandengine/components';
import { GlobalEvents } from '../core/global-events.js';
import {
    GameFlowStates,
    GameFlowController,
} from '../core/game-flow-controller.js';

export class RayTypeSwitcher extends Component {
    static TypeName = 'ray-type-switcher';
    private _cursor?: Cursor;

    start() {
        this._cursor = this.object.getComponent(Cursor)!;
    }

    onActivate(): void {
        GlobalEvents.instance.gameStateChanged.add(
            this._onGameStateChanged,
            this
        );
        this._onGameStateChanged(GameFlowController.instance.currentState);
    }

    onDeactivate(): void {
        GlobalEvents.instance.gameStateChanged.remove(this._onGameStateChanged);
    }

    private _onGameStateChanged(state: GameFlowStates) {
        if (state === GameFlowStates.InGame) {
            this._cursor!.rayCastMode = 1;
        } else {
            this._cursor!.rayCastMode = 0;
        }
    }
}
